const webToNativeDynamicExpansion = {},
  webToNativeExpansion = {};
export { webToNativeDynamicExpansion, webToNativeExpansion };